(function () {
  'use strict';
  function searchUrl(action, origin, entries) {
    var url = new URL(action, origin);
    var replaced = new Set();
    entries.forEach(function (entry) {
      var key = String(entry[0]);
      if (!replaced.has(key)) { url.searchParams.delete(key); replaced.add(key); }
      var value = String(entry[1]).trim();
      if (value) url.searchParams.append(key, value);
    });
    return url.href;
  }
  function searchAreas(url) {
    return Array.from(new Set(new URL(url).searchParams.getAll('filter.p.m.custom.tile_area').filter(Boolean)));
  }
  function searchTypes(url) {
    return Array.from(new Set((new URL(url).searchParams.get('type') || '').split(',').map(function (type) { return type.trim(); }).filter(function (type) { return ['product', 'article', 'page'].includes(type); })));
  }
  function restoreSearchScope(form, url) {
    var wrapper = form.closest('.v2-search-page');
    if (!wrapper) return;
    var currentUrl = new URL(url, window.location.origin);
    var clear = wrapper.querySelector('.v2-search-empty [data-filter-clear]');
    var filterKeys = Array.from(currentUrl.searchParams.keys()).filter(function (key) { return key.indexOf('filter.') === 0; });
    if (clear) clear.hidden = filterKeys.length === 0;
    if (clear && filterKeys.length) {
      var clearUrl = new URL(currentUrl.href);
      filterKeys.forEach(function (key) { clearUrl.searchParams.delete(key); });
      clearUrl.searchParams.delete('page');
      clear.href = clearUrl.href;
    }
    var requestedTypes = searchTypes(currentUrl.href);
    var typeField = form.querySelector('input[name="type"]');
    if (typeField && requestedTypes.length) {
      typeField.value = requestedTypes.join(',');
      var productsOnly = requestedTypes.length === 1 && requestedTypes[0] === 'product';
      var scopeContainer = form.querySelector('.v2-catalogue-search__scope');
      var suggestions = wrapper.querySelector('.v2-catalogue-suggestions');
      if (scopeContainer) scopeContainer.hidden = !productsOnly;
      if (suggestions) suggestions.hidden = !productsOnly;
      if (!productsOnly) return;
    }
    var scope = form.querySelector('.v2-catalogue-search__scope select');
    // Zero-result searches can omit all native facets. Keep only the actual URL
    // selections until Shopify returns the available area choices again.
    if (!scope || scope.disabled) return;
    var areas = searchAreas(currentUrl.href);
    if (!areas.length) { scope.value = ''; return; }
    wrapper.querySelectorAll('.v2-catalogue-suggestions a').forEach(function (link) {
      var suggestionUrl = new URL(link.href, window.location.origin);
      suggestionUrl.searchParams.delete('filter.p.m.custom.tile_area');
      areas.forEach(function (area) { suggestionUrl.searchParams.append('filter.p.m.custom.tile_area', area); });
      link.href = suggestionUrl.href;
    });
    if (areas.length === 1) {
      var option = Array.from(scope.options).find(function (item) { return item.value === areas[0]; });
      if (!option) {
        option = document.createElement('option');
        option.value = areas[0];
        option.textContent = 'In: ' + areas[0] + ' tiles';
        scope.appendChild(option);
      }
      scope.value = areas[0];
    } else {
      scope.disabled = true;
      scope.options[0].textContent = 'In selected tile areas';
      areas.forEach(function (area) {
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = 'filter.p.m.custom.tile_area'; input.value = area;
        scope.parentElement.appendChild(input);
      });
    }
  }
  function galleryIndex(index, direction, count) {
    return count > 0 ? ((index + direction) % count + count) % count : 0;
  }
  function coverCrop(imageWidth, imageHeight, frameWidth, frameHeight, points) {
    if (!(imageWidth > 0 && imageHeight > 0 && frameWidth > 0 && frameHeight > 0)) return null;
    var scale = Math.max(frameWidth / imageWidth, frameHeight / imageHeight);
    function offset(size, frame, values) {
      var overflow = size - frame;
      var centered = overflow / 2;
      if (!values.length) return centered;
      var lower = Math.max(0, Math.max.apply(null, values) - frame + 12);
      var upper = Math.min(overflow, Math.min.apply(null, values) - 12);
      return lower <= upper ? Math.max(lower, Math.min(upper, centered)) : centered;
    }
    var valid = points.filter(function (p) { return Number.isFinite(p.x) && Number.isFinite(p.y); });
    var width = imageWidth * scale;
    var height = imageHeight * scale;
    var left = offset(width, frameWidth, valid.map(function (p) { return width * p.x / 100; }));
    var top = offset(height, frameHeight, valid.map(function (p) { return height * p.y / 100; }));
    return { left: left, top: top, xPercent: width > frameWidth ? left / (width - frameWidth) * 100 : 50, yPercent: height > frameHeight ? top / (height - frameHeight) * 100 : 50 };
  }
  function coverPoint(imageWidth, imageHeight, frameWidth, frameHeight, x, y, offsetLeft, offsetTop) {
    if (!(imageWidth > 0 && imageHeight > 0 && frameWidth > 0 && frameHeight > 0)) return null;
    var scale = Math.max(frameWidth / imageWidth, frameHeight / imageHeight);
    var left = imageWidth * scale * x / 100 - (offsetLeft === undefined ? (imageWidth * scale - frameWidth) / 2 : offsetLeft);
    var top = imageHeight * scale * y / 100 - (offsetTop === undefined ? (imageHeight * scale - frameHeight) / 2 : offsetTop);
    return { left: left, top: top, visible: left >= 0 && left <= frameWidth && top >= 0 && top <= frameHeight };
  }
  function recentIds(raw, limit) {
    try {
      var items = JSON.parse(raw || '[]');
      if (!Array.isArray(items)) return [];
      return Array.from(new Set(items.filter(function (id) { return /^(?:[1-9]\d*)$/.test(String(id)) && (typeof id === 'string' || typeof id === 'number'); }).map(String))).slice(0, Math.max(0, Math.min(24, Number(limit) || 8)));
    } catch (_) { return []; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { searchUrl: searchUrl, searchAreas: searchAreas, searchTypes: searchTypes, restoreSearchScope: restoreSearchScope, galleryIndex: galleryIndex, coverPoint: coverPoint, coverCrop: coverCrop, recentIds: recentIds };
  if (typeof document === 'undefined') return;
  function initRecent(recent) {
    if (recent.dataset.v2RecentReady) return;
    recent.dataset.v2RecentReady = 'true';
    var desktop = window.matchMedia('(min-width: 1008px)');
    var products = recent.querySelector('[data-v2-recent-products]');
    var all = recent.querySelector('[data-v2-recent-all]');
    var controller;
    var lastIds = '';
    var expanded = false;
    function displayCards() {
      var cards = Array.from(products.children);
      cards.forEach(function (card, i) { card.hidden = !expanded && i >= 3; });
      all.hidden = cards.length <= 3;
      all.setAttribute('aria-expanded', String(expanded));
      all.querySelector('span').textContent = expanded ? 'Show less' : 'View all';
      recent.querySelector('[data-v2-recent-status]').textContent = 'Showing ' + (expanded ? cards.length : Math.min(3, cards.length)) + ' recently viewed products';
    }
    async function load() {
      if (controller) { controller.abort(); controller = null; }
      if (!desktop.matches) { recent.hidden = true; return; }
      var ids;
      try { ids = recentIds(window.localStorage.getItem('recentlyViewedProducts'), recent.dataset.viewedCount); } catch (_) { ids = []; }
      if (!ids.length) { recent.hidden = true; return; }
      if (lastIds === ids.join(',')) { recent.hidden = false; return; }
      recent.hidden = true;
      var request = new AbortController();
      controller = request;
      var url = new URL(recent.dataset.searchUrl, window.location.origin);
      url.searchParams.set('section_id', recent.dataset.sectionId);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
      try {
        var response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
        if (!response.ok) throw new Error('Recent product response');
        var content = new DOMParser().parseFromString(await response.text(), 'text/html');
        var source = content.querySelector('[data-v2-recent-products]');
        if (!source || controller !== request) return;
        var cards = Array.from(source.children).filter(function (card) { return ids.includes(card.dataset.v2RecentProduct); });
        cards.sort(function (a, b) { return ids.indexOf(a.dataset.v2RecentProduct) - ids.indexOf(b.dataset.v2RecentProduct); });
        products.replaceChildren.apply(products, cards);
        if (!cards.length) { recent.hidden = true; return; }
        products.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
          var saved = !!(window.Wishlist && window.Wishlist.has(button.dataset.wishlistId));
          button.classList.toggle('is-saved', saved);
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
        });
        expanded = false;
        displayCards();
        lastIds = ids.join(',');
        recent.hidden = !desktop.matches;
        recent.closest('.shopify-section').style.display = 'block';
      } catch (_) { if (controller === request) recent.hidden = true; }
      finally { if (controller === request) controller = null; }
    }
    function storageChanged(event) { if (event.key === 'recentlyViewedProducts' || event.key === null) load(); }
    all.addEventListener('click', function () { expanded = !expanded; displayCards(); });
    desktop.addEventListener('change', load);
    window.addEventListener('storage', storageChanged);
    recent._v2RecentCleanup = function () { if (controller) controller.abort(); desktop.removeEventListener('change', load); window.removeEventListener('storage', storageChanged); delete recent.dataset.v2RecentReady; };
    load();
  }
  function initGallery(gallery) {
    if (gallery.dataset.v2ContextReady) return;
    gallery.dataset.v2ContextReady = 'true';
    var slides = Array.from(gallery.querySelectorAll('[data-v2-context-slide]'));
    if (!slides.length) return;
    var active = 0;
    function placePins() {
      var media = slides[active].querySelector('[data-v2-context-media]');
      var image = media.querySelector('img');
      var pins = Array.from(media.querySelectorAll('[data-v2-context-pin]'));
      var crop = coverCrop(image.naturalWidth, image.naturalHeight, media.clientWidth, media.clientHeight, pins.map(function (pin) { return { x: Number(pin.dataset.pinX), y: Number(pin.dataset.pinY) }; }));
      if (crop) image.style.objectPosition = crop.xPercent + '% ' + crop.yPercent + '%';
      pins.forEach(function (pin) {
        var point = crop && coverPoint(image.naturalWidth, image.naturalHeight, media.clientWidth, media.clientHeight, Number(pin.dataset.pinX), Number(pin.dataset.pinY), crop.left, crop.top);
        pin.hidden = !point || !point.visible;
        if (point) { pin.style.left = point.left + 'px'; pin.style.top = point.top + 'px'; }
      });
    }
    function show(index) {
      active = index;
      slides.forEach(function (slide, i) { slide.hidden = i !== active; });
      gallery.querySelector('[data-v2-context-position]').textContent = String(active + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      gallery.querySelectorAll('[data-v2-context-peek]').forEach(function (peek) {
        var media = slides[galleryIndex(active, Number(peek.dataset.v2ContextPeek), slides.length)].querySelector('[data-v2-context-media]');
        peek.src = media.dataset.peekSrc;
        peek.hidden = false;
      });
      placePins();
    }
    gallery.querySelectorAll('[data-v2-context-direction]').forEach(function (button) {
      button.addEventListener('click', function () { show(galleryIndex(active, Number(button.dataset.v2ContextDirection), slides.length)); });
    });
    gallery.querySelector('.v2-catalogue-context__controls').addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(galleryIndex(active, event.key === 'ArrowRight' ? 1 : -1, slides.length));
      }
    });
    slides.forEach(function (slide) { slide.querySelector('[data-v2-context-media] img').addEventListener('load', placePins); });
    var observer;
    if (window.ResizeObserver) {
      observer = new ResizeObserver(placePins);
      observer.observe(gallery);
    } else window.addEventListener('resize', placePins);
    gallery._v2ContextCleanup = function () { if (observer) observer.disconnect(); else window.removeEventListener('resize', placePins); };
    show(0);
  }
  function init(root) {
    root.querySelectorAll('[data-v2-recent]').forEach(initRecent);
    root.querySelectorAll('[data-v2-catalogue-search]').forEach(function (form) {
      if (form.dataset.v2SearchReady) return;
      form.dataset.v2SearchReady = 'true';
      var query = form.querySelector('[data-v2-query]');
      var scope = form.querySelector('[data-v2-query-scope]');
      if (scope && window.matchMedia('(max-width: 1007px)').matches && form.dataset.mobileScope) scope.value = form.dataset.mobileScope;
      restoreSearchScope(form, window.location.href);
      form.addEventListener('v2:search-controls', function (event) { restoreSearchScope(form, event.detail.url); });
      form.addEventListener('submit', function (event) {
        if (!query.value.trim()) { event.preventDefault(); query.focus(); return; }
        event.preventDefault();
        window.location.assign(searchUrl(form.action, window.location.origin, Array.from(new FormData(form).entries())));
      });
    });
    root.querySelectorAll('[data-v2-context-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-v2-catalogue-faq]').forEach(function (faq) {
      if (faq.dataset.v2FaqReady) return;
      faq.dataset.v2FaqReady = 'true';
      var items = Array.from(faq.querySelectorAll('details'));
      var all = faq.querySelector('[data-v2-faq-all]');
      var mobile = window.matchMedia('(max-width: 1007px)');
      var expandingAll = false;
      function reset() {
        expandingAll = false;
        items.forEach(function (item, i) { item.open = !mobile.matches && i === 0; });
        if (all) { all.setAttribute('aria-expanded', 'false'); all.querySelector('span').textContent = all.dataset.labelAll; }
      }
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (expandingAll && !item.open) {
            expandingAll = false;
            if (all) { all.setAttribute('aria-expanded', 'false'); all.querySelector('span').textContent = all.dataset.labelAll; }
          }
          if (item.open && !expandingAll) items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
      if (all) {
        all.hidden = false;
        all.addEventListener('click', function () {
          expandingAll = !expandingAll;
          items.forEach(function (item) { item.open = expandingAll; });
          all.setAttribute('aria-expanded', String(expandingAll));
          all.querySelector('span').textContent = expandingAll ? all.dataset.labelLess : all.dataset.labelAll;
        });
      }
      mobile.addEventListener('change', reset);
      faq._v2FaqCleanup = function () { mobile.removeEventListener('change', reset); };
      reset();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-v2-recent]').forEach(function (recent) { if (recent._v2RecentCleanup) recent._v2RecentCleanup(); });
    event.target.querySelectorAll('[data-v2-context-gallery]').forEach(function (gallery) { if (gallery._v2ContextCleanup) gallery._v2ContextCleanup(); });
    event.target.querySelectorAll('[data-v2-catalogue-faq]').forEach(function (faq) { if (faq._v2FaqCleanup) faq._v2FaqCleanup(); });
  });
})();
